<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div [ngClass]="isHeadline ? 'col-12' : 'col-10'">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input id="name" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>

            @if (!isHeadline) {
                <div class="col-2">
                    <div class="form-group">
                        <label for="rank">Rank</label>
                        <wj-combo-box
                            id="rank"
                            [(ngModel)]="target.rank"
                            name="rank"
                            [itemsSource]="ranksList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>

        <div class="row">
            <div [ngClass]="isHeadline ? 'col-6' : 'col-12'">
                <div class="form-group">
                    <label for="userId">Who</label>
                    <wj-combo-box
                        id="userId"
                        [(ngModel)]="target.userId"
                        name="userId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>

            @if (isHeadline) {
                <div class="col-6">
                    <div class="form-group">
                        <label for="expirationDate">Expiration Date</label>
                        <wj-input-date
                            id="expirationDate"
                            [(ngModel)]="target.expirationDate"
                            name="expirationDate"
                            [isRequired]="false"
                        ></wj-input-date>
                    </div>
                </div>
            }
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="meetings">Associate With Meeting(s)</label>
                    <wj-multi-select
                        name="meetings"
                        [showFilterInput]="true"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [checkedMemberPath]="'$checked'"
                        [headerFormat]="'{count:n0} items'"
                        [itemsSource]="meetingsList"
                        [placeholder]="'No Meeting Association'"
                    >
                    </wj-multi-select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="details">Details</label>
                    <quill-editor
                        #quillEditorRef
                        style="width: 100%"
                        [(ngModel)]="target.details"
                        name="details"
                        [styles]="{ height: '200px' }"
                        [modules]="editorModules"
                    >
                    </quill-editor>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
